export interface FaqItem {
  question: string;
  answer: string;
}

export const faqList: FaqItem[] = [
  {
    question: "O que é o Doisplay?",
    answer: "O Doisplay é uma plataforma de streaming e indexação de entretenimento 100% aberta, feita para você assistir a filmes, séries, gameplays e curiosidades direto no celular ou computador, sem burocracia."
  },
  {
    question: "Quanto custa para usar?",
    answer: "É totalmente gratuito para acessar e curtir os conteúdos. Se você curtir e compartilhar o projeto com amigos e sua familia nos ajuda muito, e quiser ajudar a manter e melhorar ainda mais o site, aceitamos apoio voluntário com qualquer valor via Pix (basta clicar no botão Pix disponível no rodapé do site!)."
  },
  {
    question: "Onde posso assistir?",
    answer: "Em qualquer lugar! O Doisplay roda direto no navegador do seu celular, tablet, computador ou Smart TV, sem precisar baixar aplicativos."
  },
  {
    question: "O que eu posso assistir?",
    answer: "Você encontra uma curadoria pesada de filmes selecionados, cortes de animes, gameplays dos jogos do momento, conteúdos de tecnologia e curiosidades imperdíveis."
  },
  {
    question: "O Doisplay é adequado para crianças?",
    answer: "A maioria do nosso conteúdo é voltada para o público jovem e adulto (cultura pop e games). Recomendamos que os responsáveis acompanhem o uso dos menores de idade."
  },
  {
    question: "Existem anúncios na plataforma?",
    answer: "Sim, existem alguns anúncios. Eles são importantes para ajudar a manter a infraestrutura e valorizar os criadores dos canais. Fique tranquilo: eles não atrapalham sua experiência, pois aparecem apenas de forma leve no início ou no final dos vídeos."
  },
  {
    question: "Por que um vídeo pode aparecer como indisponível?",
    answer: "Isso ocorre raramente se o criador original do vídeo no YouTube alterar as permissões de exibição externa. Se notar algum link instável, nossa equipe atualiza rapidamente."
  },
  {
    question: "Como posso fazer uma denúncia ou reportar um problema?",
    answer: "Prezamos por uma comunidade segura. Se identificar algo indevido ou receber notificações relativas aos termos, entre em contato imediatamente para análise e diretrizes de segurança."
  },
  {
    question: "Preciso criar conta ou assinar algum plano?",
    answer: "No momento, o Doisplay funciona no modelo aberto: é só entrar, escolher o que quer ver e dar o play na hora, sem mensalidades ou cadastros chatos. No futuro, poderemos adicionar conteúdos e planos premium exclusivos para quem quiser ir além!"
  },
  {
    question: "Como posso alterar a legenda e o idioma do vídeo?",
    answer: "É muito simples! Basta dar um toque ou clicar no vídeo para exibir os controles, clicar no ícone de engrenagem (configurações) e escolher a legenda e o idioma desejados. Se a imagem não estiver nítida, você também pode alterar a qualidade para 1080p por esse mesmo menu."
  },
  {
    question: "Por que alguns filmes exibem apenas o trailer oficial?",
    answer: "Para respeitar os direitos autorais e apoiar a indústria cinematográfica, os grandes lançamentos de cinema exibem apenas o trailer oficial legendado. Os filmes completos e games liberadas ficam disponíveis em nossa curadoria de conteúdos abertos!"
  },
  {
    question: "Com quem falo se precisar de suporte ou contato?",
    answer: "Você pode falar diretamente com nossa equipe utilizando os canais de atendimento e o formulário de feedback disponíveis logo abaixo."
  }
];